import PaymentFailPage from './payment-fail-page'
export default PaymentFailPage;